<entity-search [entityName]="entityName" [showAllFilters]="showAllFilters" (entitySelected)="goToDetail($event)"
               (recentReleasesRequested)="goToRecentReleases($event)" [newEntityAvailable]="false"></entity-search>
